const state = {
  // 当前激活的导航 index notice help
  navActive: "index",
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js